import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VenuAccomodation.css";

const VenuAccomodation = () => {
  const [accommodations, setAccommodations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAccommodations = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/accomodations`
        );
        setAccommodations(response.data.accommodations || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching accommodation details:", error);
        setError("Error loading accommodation information");
        setLoading(false);
      }
    };

    fetchAccommodations();
  }, []);

  return (
    <div className="venue-accommodation-container">
      <div className="venue-accommodation-header">
        <h1 className="venue-accommodation-title">Accommodation Details</h1>
        <p className="venue-accommodation-subtitle">Conference Stay Options & Facilities</p>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          Loading accommodations...
        </div>
      ) : error ? (
        <div className="error-state">{error}</div>
      ) : (
        <div className="venue-accommodation-content">
          {accommodations.length > 0 ? (
            <div className="venue-accommodation-grid">
              {accommodations.map((accommodation) => (
                <div key={accommodation._id} className="venue-accommodation-card">
                  <div className="venue-accommodation-image-container">
                    {accommodation.imageUrl && (
                      <img
                        src={accommodation.imageUrl}
                        alt={accommodation.title}
                        className="venue-accommodation-image"
                      />
                    )}
                  </div>
                  <div className="venue-accommodation-details">
                    <h3>{accommodation.title}</h3>
                    <p className="venue-accommodation-description">{accommodation.description}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-data">No accommodation details available</div>
          )}
        </div>
      )}
    </div>
  );
};

export default VenuAccomodation;